(function() {
  'use strict';

  // ═══════════════════════════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════════════════════════
  var state = {
    traffic: 1000,
    growth: 10,
    convRate: 2.5,
    custValue: 500,
    monthlySpend: 2500,
    setupCost: 10000,
    cpc: 4.50
  };

  // ═══════════════════════════════════════════════════════════════
  // INDUSTRY PRESETS
  // ═══════════════════════════════════════════════════════════════
  var presets = {
    legal:      { traffic: 800,  growth: 12, convRate: 1.8, custValue: 3500, cpc: 12.00, label: 'Legal Services' },
    healthcare: { traffic: 1200, growth: 10, convRate: 3.0, custValue: 800,  cpc: 5.50,  label: 'Healthcare' },
    hvac:       { traffic: 600,  growth: 15, convRate: 3.2, custValue: 450,  cpc: 6.00,  label: 'HVAC' },
    dental:     { traffic: 900,  growth: 11, convRate: 3.5, custValue: 600,  cpc: 7.50,  label: 'Dental' },
    saas:       { traffic: 2000, growth: 8,  convRate: 2.1, custValue: 1200, cpc: 8.00,  label: 'SaaS' },
    realestate: { traffic: 1500, growth: 9,  convRate: 1.5, custValue: 4000, cpc: 3.80,  label: 'Real Estate' },
    ecommerce:  { traffic: 3000, growth: 10, convRate: 2.8, custValue: 85,   cpc: 1.20,  label: 'E Commerce' },
    construction:{ traffic: 500, growth: 14, convRate: 2.5, custValue: 2500, cpc: 4.50,  label: 'Construction' }
  };

  // ═══════════════════════════════════════════════════════════════
  // CALCULATION ENGINE
  // ═══════════════════════════════════════════════════════════════
  function calculate() {
    var s = state;
    var cr = s.convRate / 100;
    var gr = s.growth / 100;
    var months = [];
    var cumRevenue = 0;
    var cumCost = s.setupCost;
    var breakEven = 0;

    for (var m = 1; m <= 12; m++) {
      var monthTraffic = s.traffic * Math.pow(1 + gr, m);
      var monthRevenue = monthTraffic * cr * s.custValue;
      cumRevenue += monthRevenue;
      cumCost += s.monthlySpend;

      months.push({
        month: m,
        traffic: Math.round(monthTraffic),
        revenue: monthRevenue,
        cumRevenue: cumRevenue,
        cumCost: cumCost,
        profit: cumRevenue - cumCost
      });

      if (breakEven === 0 && cumRevenue >= cumCost) {
        breakEven = m;
      }
    }

    var last = months[11];
    var currentMonthlyRev = s.traffic * cr * s.custValue;
    var month12Traffic = last.traffic;
    var month12Rev = last.revenue;
    var totalRevenue = last.cumRevenue;
    var totalCost = last.cumCost;
    var roi = totalCost > 0 ? ((totalRevenue - totalCost) / totalCost) * 100 : 0;
    var adsEquivMonthly = month12Traffic * s.cpc;
    var adsEquivAnnual = 0;
    for (var i = 0; i < 12; i++) {
      adsEquivAnnual += months[i].traffic * s.cpc;
    }
    var savingsVsAds = adsEquivAnnual - totalCost;

    return {
      months: months,
      currentMonthlyRev: currentMonthlyRev,
      month12Traffic: month12Traffic,
      month12Rev: month12Rev,
      totalRevenue: totalRevenue,
      totalCost: totalCost,
      roi: roi,
      breakEven: breakEven,
      adsEquivMonthly: adsEquivMonthly,
      adsEquivAnnual: adsEquivAnnual,
      savingsVsAds: savingsVsAds
    };
  }

  // ═══════════════════════════════════════════════════════════════
  // NUMBER FORMATTING
  // ═══════════════════════════════════════════════════════════════
  function fmtMoney(n) {
    if (Math.abs(n) >= 1000000) return '$' + (n / 1000000).toFixed(1) + 'M';
    if (Math.abs(n) >= 10000) return '$' + Math.round(n).toLocaleString('en-US');
    return '$' + n.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fmtNum(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  function fmtPct(n) {
    return n.toFixed(1) + '%';
  }

  // ═══════════════════════════════════════════════════════════════
  // SVG CHART
  // ═══════════════════════════════════════════════════════════════
  function renderChart(data) {
    var svg = document.getElementById('roi-chart');
    if (!svg) return;

    var w = 760, h = 300, pad = { t: 20, r: 20, b: 40, l: 65 };
    var cw = w - pad.l - pad.r;
    var ch = h - pad.t - pad.b;

    // Find max value for scale
    var maxVal = 0;
    for (var i = 0; i < data.months.length; i++) {
      maxVal = Math.max(maxVal, data.months[i].cumRevenue, data.months[i].cumCost);
    }
    if (data.adsEquivAnnual > 0) {
      var cumAds = 0;
      for (var i = 0; i < data.months.length; i++) {
        cumAds += data.months[i].traffic * state.cpc;
        maxVal = Math.max(maxVal, cumAds);
      }
    }
    maxVal = Math.ceil(maxVal / 1000) * 1000;
    if (maxVal === 0) maxVal = 1000;

    function x(m) { return pad.l + ((m - 1) / 11) * cw; }
    function y(v) { return pad.t + ch - (v / maxVal) * ch; }

    var html = '';

    // Grid lines
    var gridSteps = 5;
    for (var g = 0; g <= gridSteps; g++) {
      var gv = (maxVal / gridSteps) * g;
      var gy = y(gv);
      html += '<line x1="' + pad.l + '" y1="' + gy + '" x2="' + (w - pad.r) + '" y2="' + gy + '" stroke="rgba(255,255,255,0.06)" stroke-width="1"/>';
      html += '<text x="' + (pad.l - 10) + '" y="' + (gy + 4) + '" fill="#6a6a80" font-size="11" text-anchor="end" font-family="sans-serif">' + fmtMoney(gv) + '</text>';
    }

    // Month labels
    for (var m = 1; m <= 12; m++) {
      html += '<text x="' + x(m) + '" y="' + (h - 8) + '" fill="#6a6a80" font-size="11" text-anchor="middle" font-family="sans-serif">M' + m + '</text>';
    }

    // Revenue line path
    var revPath = 'M' + x(1) + ',' + y(data.months[0].cumRevenue);
    for (var i = 1; i < 12; i++) {
      revPath += ' L' + x(i + 1) + ',' + y(data.months[i].cumRevenue);
    }

    // Revenue fill (area under curve)
    var revFill = revPath + ' L' + x(12) + ',' + y(0) + ' L' + x(1) + ',' + y(0) + ' Z';
    html += '<defs><linearGradient id="revGrad" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#00E5FF" stop-opacity="0.25"/><stop offset="100%" stop-color="#00E5FF" stop-opacity="0.02"/></linearGradient></defs>';
    html += '<path d="' + revFill + '" fill="url(#revGrad)"/>';
    html += '<path d="' + revPath + '" fill="none" stroke="#00E5FF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>';

    // Cost line
    var costPath = 'M' + x(1) + ',' + y(data.months[0].cumCost);
    for (var i = 1; i < 12; i++) {
      costPath += ' L' + x(i + 1) + ',' + y(data.months[i].cumCost);
    }
    html += '<path d="' + costPath + '" fill="none" stroke="#E930FF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>';

    // Google Ads equivalent line (dashed)
    var cumAds = 0;
    var adsPath = '';
    for (var i = 0; i < 12; i++) {
      cumAds += data.months[i].traffic * state.cpc;
      if (i === 0) adsPath = 'M' + x(1) + ',' + y(cumAds);
      else adsPath += ' L' + x(i + 1) + ',' + y(cumAds);
    }
    html += '<path d="' + adsPath + '" fill="none" stroke="#ff4d6a" stroke-width="1.5" stroke-dasharray="6,4" opacity="0.7"/>';

    // Break even marker
    if (data.breakEven > 0 && data.breakEven <= 12) {
      var bx = x(data.breakEven);
      var by = y(data.months[data.breakEven - 1].cumRevenue);
      html += '<circle cx="' + bx + '" cy="' + by + '" r="6" fill="#0D0D10" stroke="#00E5FF" stroke-width="2"/>';
      html += '<circle cx="' + bx + '" cy="' + by + '" r="3" fill="#00E5FF"><animate attributeName="r" values="3;5;3" dur="2s" repeatCount="indefinite"/><animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite"/></circle>';
      html += '<text x="' + bx + '" y="' + (by - 14) + '" fill="#00E5FF" font-size="11" text-anchor="middle" font-weight="600" font-family="sans-serif">Break Even</text>';
    }

    // Data point dots
    for (var i = 0; i < 12; i++) {
      html += '<circle cx="' + x(i + 1) + '" cy="' + y(data.months[i].cumRevenue) + '" r="3" fill="#00E5FF"/>';
      html += '<circle cx="' + x(i + 1) + '" cy="' + y(data.months[i].cumCost) + '" r="3" fill="#E930FF"/>';
    }

    // Legend
    html += '<circle cx="' + (pad.l + 10) + '" cy="' + (pad.t + 4) + '" r="4" fill="#00E5FF"/>';
    html += '<text x="' + (pad.l + 20) + '" y="' + (pad.t + 8) + '" fill="#c0c0d0" font-size="11" font-family="sans-serif">Cumulative Revenue</text>';
    html += '<circle cx="' + (pad.l + 160) + '" cy="' + (pad.t + 4) + '" r="4" fill="#E930FF"/>';
    html += '<text x="' + (pad.l + 170) + '" y="' + (pad.t + 8) + '" fill="#c0c0d0" font-size="11" font-family="sans-serif">Cumulative SEO Cost</text>';
    html += '<line x1="' + (pad.l + 310) + '" y1="' + (pad.t + 4) + '" x2="' + (pad.l + 330) + '" y2="' + (pad.t + 4) + '" stroke="#ff4d6a" stroke-width="1.5" stroke-dasharray="4,3"/>';
    html += '<text x="' + (pad.l + 336) + '" y="' + (pad.t + 8) + '" fill="#c0c0d0" font-size="11" font-family="sans-serif">Google Ads Equivalent</text>';

    svg.innerHTML = html;
  }

  // ═══════════════════════════════════════════════════════════════
  // UI UPDATE
  // ═══════════════════════════════════════════════════════════════
  function update() {
    var data = calculate();

    setText('out-current-rev', fmtMoney(data.currentMonthlyRev));
    setText('out-m12-traffic', fmtNum(data.month12Traffic) + '/mo');
    setText('out-m12-rev', fmtMoney(data.month12Rev) + '/mo');
    setText('out-total-rev', fmtMoney(data.totalRevenue));
    setText('out-total-cost', fmtMoney(data.totalCost));
    setText('out-break-even', data.breakEven > 0 ? 'Month ' + data.breakEven : '12+ months');
    setText('out-ads-equiv', fmtMoney(data.adsEquivAnnual) + '/yr');
    setText('out-savings', fmtMoney(data.savingsVsAds));

    var roiEl = document.getElementById('out-roi');
    if (roiEl) {
      roiEl.textContent = fmtPct(data.roi);
      roiEl.className = 'roi-calc__big-num';
      if (data.roi > 200) roiEl.className += ' roi-calc__big-num--green';
      else if (data.roi > 0) roiEl.className += ' roi-calc__big-num--yellow';
      else roiEl.className += ' roi-calc__big-num--red';
    }

    renderChart(data);
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  // ═══════════════════════════════════════════════════════════════
  // INPUT BINDING
  // ═══════════════════════════════════════════════════════════════
  function bindInput(sliderId, numberId, stateKey, transform) {
    var slider = document.getElementById(sliderId);
    var number = document.getElementById(numberId);
    if (!slider || !number) return;

    var t = transform || function(v) { return parseFloat(v); };

    slider.addEventListener('input', function() {
      var v = t(this.value);
      state[stateKey] = v;
      number.value = v;
      update();
    });

    number.addEventListener('input', function() {
      var v = t(this.value);
      if (isNaN(v) || v < 0) return;
      state[stateKey] = v;
      slider.value = v;
      update();
    });

    number.addEventListener('blur', function() {
      var v = t(this.value);
      if (isNaN(v) || v < 0) { v = 0; }
      state[stateKey] = v;
      slider.value = v;
      number.value = v;
      update();
    });
  }

  // ═══════════════════════════════════════════════════════════════
  // PRESETS
  // ═══════════════════════════════════════════════════════════════
  function applyPreset(key) {
    var p = presets[key];
    if (!p) return;

    state.traffic = p.traffic;
    state.growth = p.growth;
    state.convRate = p.convRate;
    state.custValue = p.custValue;
    state.cpc = p.cpc;

    // Update all input fields
    setInput('in-traffic', 'num-traffic', p.traffic);
    setInput('in-growth', 'num-growth', p.growth);
    setInput('in-conv', 'num-conv', p.convRate);
    setInput(null, 'num-custval', p.custValue);
    setInput(null, 'num-cpc', p.cpc);

    // Highlight active preset
    document.querySelectorAll('.roi-calc__preset').forEach(function(el) {
      el.classList.remove('active');
    });
    var btn = document.querySelector('[data-preset="' + key + '"]');
    if (btn) btn.classList.add('active');

    update();
  }

  function setInput(sliderId, numberId, val) {
    if (sliderId) { var s = document.getElementById(sliderId); if (s) s.value = val; }
    var n = document.getElementById(numberId); if (n) n.value = val;
  }

  // ═══════════════════════════════════════════════════════════════
  // SHARE / COPY
  // ═══════════════════════════════════════════════════════════════
  function copyResults() {
    var data = calculate();
    var text = 'My SEO ROI Projection (via OmnifySEO)\n\n' +
      'Current Traffic: ' + fmtNum(state.traffic) + '/mo → Projected: ' + fmtNum(data.month12Traffic) + '/mo\n' +
      '12 Month Revenue: ' + fmtMoney(data.totalRevenue) + '\n' +
      '12 Month Investment: ' + fmtMoney(data.totalCost) + '\n' +
      'ROI: ' + fmtPct(data.roi) + '\n' +
      'Break Even: ' + (data.breakEven > 0 ? 'Month ' + data.breakEven : '12+ months') + '\n' +
      'Google Ads Equivalent: ' + fmtMoney(data.adsEquivAnnual) + '/yr\n\n' +
      'Calculate yours: https://omnifyseo.com/pages/seo-roi-calculator';

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() {
        showCopyFeedback();
      });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showCopyFeedback();
    }
  }

  function showCopyFeedback() {
    var btn = document.getElementById('roi-copy-btn');
    if (!btn) return;
    var orig = btn.textContent;
    btn.textContent = '✓ Copied!';
    btn.style.borderColor = 'rgba(0,229,255,0.5)';
    btn.style.color = '#00E5FF';
    setTimeout(function() {
      btn.textContent = orig;
      btn.style.borderColor = '';
      btn.style.color = '';
    }, 2000);
  }

  // ═══════════════════════════════════════════════════════════════
  // INIT
  // ═══════════════════════════════════════════════════════════════
  function init() {
    bindInput('in-traffic', 'num-traffic', 'traffic');
    bindInput('in-growth', 'num-growth', 'growth');
    bindInput('in-conv', 'num-conv', 'convRate');
    bindInput(null, 'num-custval', 'custValue');
    bindInput(null, 'num-spend', 'monthlySpend');
    bindInput(null, 'num-setup', 'setupCost');
    bindInput(null, 'num-cpc', 'cpc');

    // Preset buttons
    document.querySelectorAll('.roi-calc__preset').forEach(function(btn) {
      btn.addEventListener('click', function() {
        applyPreset(this.getAttribute('data-preset'));
      });
    });

    // Copy button
    var copyBtn = document.getElementById('roi-copy-btn');
    if (copyBtn) copyBtn.addEventListener('click', copyResults);

    // FAQ toggles
    document.querySelectorAll('.roi-calc__faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.classList.toggle('active');
        this.nextElementSibling.classList.toggle('open');
      });
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
